// @flow

import React from 'react';

const LabelValueSeparator = () => (
  <>:&nbsp;</>
);

export default LabelValueSeparator;
